import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevronRight",
  "use": "icon_chevronRight-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_chevronRight\"><path fill=\"currentColor\" d=\"M35.493 25.555L17.691 43.355a2.198 2.198 0 01-3.108 0l-2.077-2.076a2.198 2.198 0 01-.003-3.106L26.61 24 12.502 9.825a2.198 2.198 0 01.004-3.105l2.076-2.076a2.198 2.198 0 013.11 0l17.801 17.801c.859.859.859 2.25 0 3.11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol